export async function addCanvasPage(obj, opts = {}) {
  const { title, freeform } = obj

  if (!title) {
    return window.alert('Title is required.')
  }

  const canvasPages = this.getRootState().canvas.pages

  const exists = title === 'Default' || (canvasPages && canvasPages[title])

  const query = [
    [
      'update',
      ['canvas', 'pages', title],
      {
        title,
        freeform,
        pages: [],
        components: [],
        functions: [],
        methods: [],
        snippets: [],
        atom: [],
        files: [],
        dependencies: [],
        secrets: []
      }
    ]
  ]

  if (!canvasPages) {
    query.unshift(['update', ['canvas', 'pages'], {}])
  }

  if (exists && !opts.preventNameCheck) {
    return this.call('openNotification', {
      type: 'error',
      title: 'Such canvas page already exists.',
      message: `Canvas page with name "${title}" already exists. Please use different name`
    })
  }

  this.sdk.updateData(query, { message: `Added canvas page ${title}` })

  this.call('openCanvasPage', title)
}

export async function openCanvasPage(val) {
  let pageVal = val
  const data = this.getCanvasScope()
  const Collection = this.getCanvasCollection()
  const activeCanvasPage = this.getActiveCanvasPage()
  this.syncCanvas({ activeCanvasPage: pageVal })
  if (pageVal === activeCanvasPage) {
    return
  }

  pageVal ||= this.state.value
  data.activeCanvasPage = pageVal
  if (Collection?.update) {
    await Collection.update()
  }

  await this.getCanvasPages()?.update()

  if (this.getFilesSidebar()?.update) {
    await this.getFilesSidebar().update()
  }

  this.call('resetCanvasPan')
}

export function getCanvasPage(key) {
  const { canvas } = this.getRootState()
  return (
    canvas.pages && Object.keys(canvas.pages).length > 0 && canvas.pages[key]
  )
}

export function getCurrentCanvasPage() {
  const activeCanvasPage = this.getActiveCanvasPage()
  return this.call('getCanvasPage', activeCanvasPage)
}

export function onCurrentCanvasPage(type, key) {
  const platformState = this.getRootState()
  const activeCanvasPage = this.getActiveCanvasPage()
  const { canvas } = platformState
  return canvas.pages[activeCanvasPage][type].includes(key)
}

export function inOnCurrentCanvasPage(type, key) {
  const { canvas } = this.getRootState()
  const activeCanvasPage = this.getActiveCanvasPage()

  const isDefaultActive = activeCanvasPage === 'Default'
  const isAnywhereElse = this.call('findInOtherCanvasPages', type, key)
  if (isDefaultActive && !isAnywhereElse) {
    return true
  }

  const currentCanvas = canvas.pages[activeCanvasPage]
  const currentWhitelist = currentCanvas?.[type]
  if (currentWhitelist?.includes(key)) {
    return true
  }
}

export function findInOtherCanvasPages(type, key) {
  const platformState = this.getRootState()
  const activeCanvasPage = this.getActiveCanvasPage()
  const { canvas } = platformState
  for (const page in canvas.pages) {
    if (page === activeCanvasPage) {
      // eslint-disable-next-line no-continue
      continue
    }
    if (canvas.pages[page][type]?.includes(key)) {
      return page
    }
  }
}

export function findKeyInOtherCanvasPages(key) {
  const platformState = this.getRootState()
  const activeCanvasPage = this.getActiveCanvasPage()
  const { canvas } = platformState
  const type = this.getType(key)
  for (const page in canvas.pages) {
    if (page === activeCanvasPage) {
      // eslint-disable-next-line no-continue
      continue
    }
    if (canvas.pages[page][type]?.includes(key)) {
      return page
    }
  }
}

export async function deleteCanvasPage(val) {
  let pageVal = val
  const platformState = this.getRootState()
  const activeCanvasPage = this.getActiveCanvasPage()
  pageVal ||= this.state.value
  if (pageVal === 'Default') {
    el.call('openNotification', {
      type: 'warning',
      title: `Default can't be removed`,
      message: `Default canvas page is built-in and can't be removed`
    })
    return
  }
  if (!window.confirm(`Do you want to remove ${pageVal} page?`)) {
    return
  }
  let moveTo = window.prompt('Where do you want to move all data?', 'Default')
  const { canvas } = platformState
  const canvasPage = canvas.pages[pageVal] || {}
  // delete canvas.pages[val]

  const query = [['delete', ['canvas', 'pages', pageVal]]]

  if (canvas.pages[moveTo] && moveTo !== 'Default') {
    this.call('deepMerge', canvas.pages[moveTo], canvasPage)
    query.push(['update', ['canvas', 'pages', moveTo], canvas.pages[moveTo]])
  } else {
    moveTo = 'Default'
  }
  // if (val !== canvasPage.pageVal) {
  //   delete canvas.pages[pageVal.pageVal]
  // }

  this.sdk.updateData(query, { message: `Removed canvas page ${pageVal}` })

  await this.getCanvasPages().update()
  if (activeCanvasPage === moveTo || activeCanvasPage === val) {
    await this.call('openCanvasPage', moveTo)
  }

  // await platformState.quietReplace(
  //   {
  //     canvas: platformState.canvas
  //   },
  //   {
  //     message: `Removed ${val} page. All items are moved to ${moveTo}.`
  //   }
  // )
}

export function renameCanvasPage(val) {
  let pageVal = val || this.state.value
  const platformState = this.getRootState()
  if (pageVal === 'Default') {
    el.call('openNotification', {
      type: 'warning',
      title: `Default can't be renamed`,
      message: `Default canvas page is built-in and can't be renamed`
    })
    return
  }
  const newTitle = window.prompt('Rename canvas page', pageVal)
  if (!newTitle) {
    return
  }
  const { canvas } = platformState
  const canvasPage = canvas.pages[pageVal] || {}
  // delete canvas.pages[pageVal]
  if (pageVal !== newTitle) {
    canvasPage.title = newTitle
    const query = [
      ['update', ['canvas', 'pages', newTitle], canvasPage],
      ['delete', ['canvas', 'pages', pageVal]]
    ]
    this.sdk.updateData(query, {
      message: `Renamed canvas page ${pageVal} to ${newTitle}`
    })

    this.getCanvasPages().update()
  }

  // platformState.quietReplace(
  //   {
  //     canvas: platformState.canvas
  //   },
  //   {
  //     message: `Renamed canvas page "${pageVal}" to ${newTitle}.`
  //   }
  // )
}

// eslint-disable-next-line no-empty-function
export function duplicateCanvasPage() {}

export function returnAddedCanvasPageChanges(type, key) {
  const activeCanvasPage = this.getActiveCanvasPage()
  if (activeCanvasPage === 'Default') {
    return
  }

  const canvasPages = this.getRootState('canvas').pages || {}
  const tuples = []

  // 1. Add the key to the active canvas page list (or ensure it exists)
  const currentList = canvasPages?.[activeCanvasPage]?.[type] || []
  const newCurrentList = currentList.includes(key)
    ? currentList
    : [...currentList, key]
  tuples.push([
    'update',
    ['canvas', 'pages', activeCanvasPage, type],
    newCurrentList
  ])

  // 2. Ensure the key is removed from *other* canvas page lists so that it
  //    is unique to the current page. This prevents unintended navigation
  //    back to "Default" when interacting with the component.
  Object.keys(canvasPages).forEach((page) => {
    if (activeCanvasPage === page) {
      return
    }
    const list = canvasPages[page]?.[type]
    if (Array.isArray(list) && list.includes(key)) {
      tuples.push([
        'update',
        ['canvas', 'pages', page, type],
        list.filter((k) => k !== key)
      ])
    }
  })

  return tuples
}

export function returnRemovedCanvasPageChanges(type, key) {
  const activeCanvasPage = this.getActiveCanvasPage()
  if (activeCanvasPage === 'Default') {
    return
  }
  const canvasPages = this.getRootState('canvas').pages || {}
  const tuples = []

  // Remove the key from the active canvas page list
  const currentList = canvasPages?.[activeCanvasPage]?.[type] || []
  if (currentList.includes(key)) {
    tuples.push([
      'update',
      ['canvas', 'pages', activeCanvasPage, type],
      currentList.filter((k) => k !== key)
    ])
  }

  return tuples
}

export async function addItemOnCanvasPage(obj) {
  const { key } = obj
  const activeCanvasPage = this.getActiveCanvasPage()
  const currentCanvas = this.call('getCurrentCanvasPage')
  const isDefault = activeCanvasPage === 'Default'
  const type = this.getType(obj)
  if (!isDefault && !currentCanvas[type]) {
    currentCanvas[type] = []
  }
  if (!isDefault && !currentCanvas[type].includes(key)) {
    currentCanvas[type].push(key)
  }
  await this.call('rerenderFileSidebarByType', type)
}

// export function removeCanvasArtboardFromCanvasPage(type, key) {
//   if (!type || !key) {
//     return this.error('Type or key is not defined to remove from canvas page')
//   }

//   const activeCanvasPage = this.getActiveCanvasPage()
//   const currentCanvas = this.call('getCurrentCanvasPage')
//   const isDefault = activeCanvasPage === 'Default'
//   if (!isDefault && currentCanvas[type].includes(key)) {
//     this.call('removeValueFromArrayAll', currentCanvas[type], key)
//     return true
//   }
// }
